module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./HotAndLastCListView.js"));
	}, "HotAndLastCListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=HotAndLastCListView!./src/pages/Learn/Course/HotAndLastCList/HotAndLastCListView.js
// module id = 1742
// module chunks = 418